import { ContentInstitutionSearchOrder } from '@/data/usecases/content/content-institution-search-order'
import { Pagination } from '@/domain/models'
import { UserContentInstitutionSearch } from '@/domain/usecases/content/user-content-institution-search'
import { UserContentSearch } from '@/domain/usecases/content/user-content-search'
import { parseNumber } from '@/main/helpers/number-helper'
import { capitalize } from '@mui/material'
import { importRemote } from '@/main/routes/helpers/loaders'
import { queryClient } from '@/infra/http'

/**
 * Loads institutions search results
 * Used for searching institutions (not content)
 */
export async function loadInstitutionsSearch(searchParams: URLSearchParams) {
  const params = createSearchParams(searchParams)
  const remote = await importRemote<UserContentInstitutionSearch>(
    'makeRemoteUserContentInstitutionSearch',
    queryClient
  )
  const data = await remote.loader(params)

  return {
    data,
    remote,
    params
  }
}

function createSearchParams(searchParams: URLSearchParams): UserContentInstitutionSearch.Params {
  const name = searchParams.get(UserContentInstitutionSearch.INSTITUTION_NAME_PARAM_NAME)
  const order = searchParams.get(UserContentInstitutionSearch.ORDER_PARAM_NAME)
  const page = searchParams.get(Pagination.PAGE_PARAM_NAME)
  const pageSize = searchParams.get(Pagination.PAGE_SIZE_PARAM_NAME)

  return {
    name: name ? capitalize(name) : undefined,
    order: parseOrder(order),
    page: parseNumber(page, Pagination.DEFAULT_PAGE)!,
    pageSize: parseNumber(pageSize, UserContentSearch.DEFAULT_PAGE_SIZE)
  }
}

function parseOrder(order: string | null): ContentInstitutionSearchOrder.Enum {
  if (order && order.length) {
    const parsed = ContentInstitutionSearchOrder.getByName(order)
    return parsed || ContentInstitutionSearchOrder.Enum.ALPHABETICAL_ASC
  }
  return ContentInstitutionSearchOrder.Enum.ALPHABETICAL_ASC
}
